/* eslint-disable sonarjs/no-duplicate-string */
import {createTheme} from '@mui/material/styles';
import '../../fonts/x5-sans-ui/WEB/X5-Sans-UI_Regular/X5-Sans-UI_Regular.css';

const nofrovTheme = createTheme({
  // Добавить шрифт X5
  typography: {
    subtitle1: {
      fontSize: 12,
    },
    p1: {
      fontSize: 16,
      fontWeight: '400',
      letterSpacing: '0.12px',
      lineHeight: '20px',
    },
    p2: {
      fontSize: 14,
      fontWeight: '400',
      letterSpacing: '0.08px',
      lineHeight: '16px',
    },
    p3: {
      fontSize: 12,
      fontWeight: '400',
      letterSpacing: '0.08px',
      lineHeight: '16px',
    },
    h3: {
      fontSize: 20,
      fontWeight: 600, // change to 500?
      letterSpacing: '0.12px',
      lineHeight: '24px',
    },
    h4: {
      fontSize: 16,
      fontWeight: 600, // change to 500?
      lineHeight: '20px',
      letterSpacing: '0.12px',
    },
    // fontFamily: `"Helvetica Neue 9", "Roboto", "Helvetica", "Arial", sans-serif`,
    // fontSize: 13,
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1E88E5',
      light: '#1976d2',
      dark: '#0D47A1',
    },
    secondary: {
      main: '#222429',
      dark: '#9299A4',
      light: '#D7D7D7',
    },
    error: {
      main: '#EE412B',
    },
    warning: {
      main: '#F9820B',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small',
        disableElevation: false,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiRadio: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
        autoSelect: true,
        clearOnBlur: true,
      },
      styleOverrides: {
        inputRoot: {
          height: '36px',
          padding: '0 !important',
          borderRadius: '4px',
          marginTop: '6px',
        },
        input: {
          height: '36px',
          padding: '0 12px !important',
          borderRadius: '4px',
        },
        popupIndicator: {
          height: '28px',
        },
        clearIndicator: {
          height: '28px',
        }
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTable: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          width: '99.9%',
        },
      },
    },
    MuiTextField: {
      defaultProps: {size: 'small'},
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2196F3 !important',
            },
          },
          '&:active': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#1E88E5 !important',
            },
          },
          '& .MuiAutocomplete-endAdornment': {
            button: {height: '28px'},
          },
        },
        inputMultiline: {
          padding: '0 !important',
        },
        inputAdornedStart: {
          padding: '0 !important',
        },
        input: {
          height: '36px',
          padding: '0 12px !important',
          fontFamily: 'X5SansUI',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '20px',
          letterSpacing: '0.12px',
          textAlign: 'left',
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          height: '40px',
          fontSize: '16px!important',
          lineHeight: '20px',
          textTransform: 'none',
        },
      },

      defaultProps: {
        disableRipple: true,
      },
    },
    MuiList: {
      defaultProps: {
        dense: true,
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
declare module '@mui/material/styles' {
  interface TypographyVariants {
    p1: React.CSSProperties;
    p2: React.CSSProperties;
    p3: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    p1?: React.CSSProperties;
    p2?: React.CSSProperties;
    p3?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    p1: true;
    p2: true;
    p3: true;
  }
}

export default nofrovTheme;
